import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
export const HorizontalCardShimmer = ({ count = 1 }) => {
  return (
    <div className="space-y-4">
      {[...Array(count)].map((_, idx) => (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: idx * 0.05 }}
          className="p-6 border rounded-lg hover:shadow-md transition-all"
        >
          <div className="flex flex-col gap-3 animate-pulse">
            <div className="flex items-start justify-between">
              <div className="space-y-3 flex-1">
                <div>
                  <div className="flex items-center gap-2">
                    <div className="w-5 h-5 bg-gray-300 rounded"></div>
                    <div className="h-5 bg-gray-300 rounded w-40"></div>
                  </div>
                  <div className="mt-2 h-4 bg-gray-200 rounded w-56"></div>
                </div>
              </div>
              <div className="h-5 w-16 bg-gray-200 rounded-full"></div>
            </div>

            <div className="flex justify-end">
              <div className="h-8 w-28 bg-gray-200 rounded-md"></div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export const DashboardcardShimmer = ({count =1 ,isSmall= false}:any) => {
  return (
     <div className="grid gap-3 sm:gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
    {[...Array(count)].map((_,index)=> (

  
     <motion.div
                  key={`shimmer-${index}`}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <Card className="overflow-hidden animate-pulse">
                    <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
                      {/* Title shimmer */}
                      <CardTitle className="text-sm font-medium text-muted-foreground w-24 h-4 bg-muted rounded-md"></CardTitle>

                      {/* Icon shimmer */}
                      <div className="p-2 rounded-lg bg-muted shrink-0 w-8 h-8"></div>
                    </CardHeader>

                    {!isSmall &&  <CardContent>
                      {/* Value shimmer */}
                      <div className="w-20 h-6 sm:h-8 bg-muted rounded-md mb-2"></div>

                      {/* Subtitle shimmer */}
                      <p className="w-16 h-3 bg-muted rounded-md"></p>
                    </CardContent>}
                  </Card>
                </motion.div>
                  ))
    
    }
    </div>
  )
}